module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/whats-happening.json
// module id = 383
// module chunks = 202169841674606